// @owners { team: patients }
import { getImage } from '~shared/assets/images/getImage';
import menopur from '~shared/assets/images/menopur@2x.png';
import rxPaperWithQuestionMark from '~shared/assets/images/rx_paper_with_question_mark@2x.png';

// Web uses the @2x assets because the web bundler serves a single resolution (no automatic @2x/@3x
// density selection like native), so the images stay crisp on retina displays. Keys must match
// progynyAssets.ts. `logo` and `rx` are getters (not direct @2x imports like the rest) so they
// re-resolve per brand on each access instead of freezing whatever getImage() returned at module
// load — e.g. FuzeRx gets its own Progyny co-brand logo and its own prescription artwork.
export const progynyAssets = {
  get logo() {
    return getImage('progynyLogo');
  },
  menopur,
  get rx() {
    return getImage('prescription');
  },
  rxPaperWithQuestionMark,
};
